export default function replaceSubdomain(newSubdomain) {
  const split = window.location.host.split(".")

  split[0] = newSubdomain
  return `${window.location.protocol}//${split.join(".")}`
}
